const React = require('react');
const toUpper = require('mn-utils/toUpper');
const map = require('mn-utils/map');
const reduce = require('mn-utils/reduce');
const withState = require('../../../../utils/withState');
const {
  apiAdminCccodeList,
  apiAdminCccodeEnable,
  apiAdminCccodeDisable,
} = require('../../../../api/admin/CCCodes');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const SwitchA = require('../../../dumb/Switch/A');
const {NETWORKS_DETAILED_NAMES} = require("../../../../constants/networks");


const NETWORK_KEY_OTHER = 'other';


module.exports = withState((setState, self, onMount) => {
  onMount(() => {
    setState({
      loading: true,
    });
    apiAdminCccodeList().finally((error, response) => {
      setState({
        tokens: response && response.list || [],
        loading: false,
      });
    });
  });


  return (state) => {
    const tokens = state.tokens || [];
    const networksMap = reduce(tokens, (a, v) => {
      const network = v.network || NETWORK_KEY_OTHER;
      (a[network] || (a[network] = [])).push(v);
      return a;
    }, {});
    const networks = reduce(networksMap, (a, tokens, id) => {
      a.push({
        id,
        tokens,
      });
      return a;
    }, []);
    networks.sort((a, b) => {
      if (a.id === NETWORK_KEY_OTHER) {
        return 1;
      }
      if (b.id === NETWORK_KEY_OTHER) {
        return -1;
      }
      return 0;
    });


    function itemIteratee(item) {
      const {
        code,
        enabled,
      } = item;

      const network = toUpper(item.network || '');
      const token = toUpper(item.token || '') || code;
      return (
        <SwitchA
          key={code}
          label={network ? (
            <div className="lh">{token}</div>
          ) : token}
          checked={enabled}
          onChange={() => {
            setState({
              loading: true,
            });
            (
              enabled
                ? apiAdminCccodeDisable
                : apiAdminCccodeEnable
            )({
              cc_code: code,
            }).finally((error, response) => {
              setState({
                loading: false,
                tokens: error ? tokens : map(tokens, (item) => {
                  return item.code === code ? {
                    ...item,
                    enabled: !enabled,
                  } : item;
                }),
              });
            });
          }}
        />
      );
    }

    const networkSynonims = {
      matic: 'Polygon'
    }

    return (
      <WrapperWithLoading
        className="w"
        loading={state.loading}
      >
        <div className="cfx mh-10 (w1/6@d3|w1/3|w1/2@m|w@m2|ph10|pb30|lt)>1">
          {map(networks, (network) => {
            const {
              id,
            } = network;
            return (
              <div key={id}>
                <div className="ttU cF">{NETWORKS_DETAILED_NAMES[id] || id}</div>
                <div className="mt5">
                  {map(network.tokens, itemIteratee, [])}
                </div>
              </div>
            );
          }, [])}
        </div>
      </WrapperWithLoading>
    );
  };
}, {});
